const Icons = {
  UserCircle: ({ fill, ...props }) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1396 15.785C14.1162 15.785 14.0812 15.785 14.0579 15.785C14.0229 15.785 13.9762 15.785 13.9412 15.785C11.2929 15.7033 9.30957 13.6383 9.30957 11.095C9.30957 8.50498 11.4212 6.39331 14.0112 6.39331C16.6012 6.39331 18.7129 8.50498 18.7129 11.095C18.7012 13.65 16.7062 15.7033 14.1746 15.785C14.1512 15.785 14.1512 15.785 14.1396 15.785ZM13.9996 8.13164C12.3662 8.13164 11.0479 9.46164 11.0479 11.0833C11.0479 12.6816 12.2962 13.9766 13.8829 14.035C13.9179 14.0233 14.0346 14.0233 14.1512 14.035C15.7146 13.9533 16.9396 12.67 16.9512 11.0833C16.9512 9.46164 15.6329 8.13164 13.9996 8.13164Z"
        fill={fill}
      />
      <path
        d="M13.9996 26.5418C10.8613 26.5418 7.86298 25.3751 5.54131 23.2518C5.33131 23.0651 5.23798 22.7851 5.26131 22.5168C5.41298 21.1285 6.27631 19.8335 7.71131 18.8768C11.188 16.5668 16.823 16.5668 20.288 18.8768C21.723 19.8451 22.5863 21.1285 22.738 22.5168C22.773 22.7968 22.668 23.0651 22.458 23.2518C20.1363 25.3751 17.138 26.5418 13.9996 26.5418ZM7.09298 22.2835C9.02965 23.9051 11.468 24.7918 13.9996 24.7918C16.5313 24.7918 18.9696 23.9051 20.9063 22.2835C20.6963 21.5718 20.1363 20.8835 19.308 20.3235C16.438 18.4101 11.573 18.4101 8.67965 20.3235C7.85131 20.8835 7.30298 21.5718 7.09298 22.2835Z"
        fill={fill}
      />
      <path
        d="M13.9997 26.5416C7.08134 26.5416 1.45801 20.9183 1.45801 13.9999C1.45801 7.08159 7.08134 1.45825 13.9997 1.45825C20.918 1.45825 26.5413 7.08159 26.5413 13.9999C26.5413 20.9183 20.918 26.5416 13.9997 26.5416ZM13.9997 3.20825C8.04967 3.20825 3.20801 8.04992 3.20801 13.9999C3.20801 19.9499 8.04967 24.7916 13.9997 24.7916C19.9497 24.7916 24.7913 19.9499 24.7913 13.9999C24.7913 8.04992 19.9497 3.20825 13.9997 3.20825Z"
        fill={fill}
      />
    </svg>
  ),
  Users: ({ fill, ...props }) => (
    <svg
      width={props.width ? props.width : 60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.8989 29.05C22.8239 29.05 22.7739 29.05 22.6989 29.05C22.5739 29.025 22.3989 29.025 22.2489 29.05C14.9989 28.825 9.52393 23.125 9.52393 16.1C9.52393 8.95 15.3489 3.125 22.4989 3.125C29.6489 3.125 35.4739 8.95 35.4739 16.1C35.4489 23.125 29.9489 28.825 22.9739 29.05C22.9489 29.05 22.9239 29.05 22.8989 29.05ZM22.4989 6.875C17.4239 6.875 13.2739 11.025 13.2739 16.1C13.2739 21.1 17.1739 25.125 22.1489 25.3C22.2989 25.275 22.6239 25.275 22.9489 25.3C27.8489 25.075 31.6989 21.05 31.7239 16.1C31.7239 11.025 27.5739 6.875 22.4989 6.875Z"
        fill={fill}
      />
      <path
        d="M41.3489 29.375C41.2739 29.375 41.1989 29.375 41.1239 29.35C40.0989 29.45 39.0489 28.725 38.9489 27.7C38.8489 26.675 39.4739 25.75 40.4989 25.625C40.7989 25.6 41.1239 25.6 41.3989 25.6C45.0489 25.4 47.8989 22.4 47.8989 18.725C47.8989 14.925 44.8239 11.85 41.0239 11.85C39.9989 11.875 39.1489 11.025 39.1489 10C39.1489 8.975 39.9989 8.125 41.0239 8.125C46.8739 8.125 51.6489 12.9 51.6489 18.75C51.6489 24.5 47.1489 29.15 41.4239 29.375C41.3989 29.375 41.3739 29.375 41.3489 29.375Z"
        fill={fill}
      />
      <path
        d="M22.924 56.375C18.024 56.375 13.099 55.125 9.37402 52.625C5.89902 50.325 3.99902 47.175 3.99902 43.75C3.99902 40.325 5.89902 37.15 9.37402 34.825C16.874 29.85 29.024 29.85 36.474 34.825C39.924 37.125 41.849 40.275 41.849 43.7C41.849 47.125 39.949 50.3 36.474 52.625C32.724 55.125 27.824 56.375 22.924 56.375ZM11.449 37.975C9.04902 39.575 7.74902 41.625 7.74902 43.775C7.74902 45.9 9.07402 47.95 11.449 49.525C17.674 53.7 28.174 53.7 34.399 49.525C36.799 47.925 38.099 45.875 38.099 43.725C38.099 41.6 36.774 39.55 34.399 37.975C28.174 33.825 17.674 33.825 11.449 37.975Z"
        fill={fill}
      />
      <path
        d="M45.8489 51.875C44.9739 51.875 44.1989 51.275 44.0239 50.375C43.8239 49.35 44.4739 48.375 45.4739 48.15C47.0489 47.825 48.4989 47.2 49.6239 46.325C51.0489 45.25 51.8239 43.9 51.8239 42.475C51.8239 41.05 51.0489 39.7 49.6489 38.65C48.5489 37.8 47.1739 37.2 45.5489 36.825C44.5489 36.6 43.8989 35.6 44.1239 34.575C44.3489 33.575 45.3489 32.925 46.3739 33.15C48.5239 33.625 50.3989 34.475 51.9239 35.65C54.2489 37.4 55.5739 39.875 55.5739 42.475C55.5739 45.075 54.2239 47.55 51.8989 49.325C50.3489 50.525 48.3989 51.4 46.2489 51.825C46.0989 51.875 45.9739 51.875 45.8489 51.875Z"
        fill={fill}
      />
    </svg>
  ),
  Clock: ({ fill, ...props }) => (
    <svg
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30 56.875C15.175 56.875 3.125 44.825 3.125 30C3.125 15.175 15.175 3.125 30 3.125C44.825 3.125 56.875 15.175 56.875 30C56.875 44.825 44.825 56.875 30 56.875ZM30 6.875C17.25 6.875 6.875 17.25 6.875 30C6.875 42.75 17.25 53.125 30 53.125C42.75 53.125 53.125 42.75 53.125 30C53.125 17.25 42.75 6.875 30 6.875Z"
        fill={fill}
      />
      <path
        d="M39.2751 39.8249C38.9501 39.8249 38.6251 39.7499 38.3251 39.5499L30.5751 34.9249C28.6501 33.7749 27.2251 31.2499 27.2251 29.0249V18.7749C27.2251 17.7499 28.0751 16.8999 29.1001 16.8999C30.1251 16.8999 30.9751 17.7499 30.9751 18.7749V29.0249C30.9751 29.9249 31.7251 31.2499 32.5001 31.6999L40.2501 36.3249C41.1501 36.8499 41.4251 37.9999 40.9001 38.8999C40.5251 39.4999 39.9001 39.8249 39.2751 39.8249Z"
        fill={fill}
      />
    </svg>
  ),
  History: ({ fill, active, ...props }) =>
    active ? (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M 16 22.75 L 8 22.75 C 2.25 22.75 2.25 19.7 2.25 17 L 2.25 16 C 2.25 13.77 2.25 11.25 7 11.25 C 8.19 11.25 8.63 11.54 9.25 12 C 9.28 12.03 9.32 12.05 9.35 12.09 L 10.37 13.17 C 11.23 14.08 12.79 14.08 13.65 13.17 L 14.67 12.09 C 14.7 12.06 14.73 12.03 14.77 12 C 15.39 11.53 15.83 11.25 17.02 11.25 C 21.77 11.25 21.77 13.77 21.77 16 L 21.77 17 C 21.75 20.82 19.82 22.75 16 22.75 Z"
          fill={fill}
        />
        <path
          d="M 7 12.75 C 3.75 12.75 3.75 13.77 3.75 16 L 3.75 17 C 3.75 19.74 3.75 21.25 8 21.25 L 16 21.25 C 18.98 21.25 20.25 19.98 20.25 17 L 20.25 16 C 20.25 13.77 20.25 12.75 17 12.75 C 16.28 12.75 16.13 12.84 15.7 13.16 L 14.73 14.19 C 14.01 14.95 13.04 15.37 12 15.37 C 10.96 15.37 9.99 14.95 9.27 14.19 L 8.3 13.16 C 7.87 12.84 7.72 12.75 7 12.75 Z"
          fill={fill}
        />
        <path
          d="M19 12.75C18.59 12.75 18.25 12.41 18.25 12V6C18.25 3.77 18.25 2.75 15 2.75H9C5.75 2.75 5.75 3.77 5.75 6V12C5.75 12.41 5.41 12.75 5 12.75C4.59 12.75 4.25 12.41 4.25 12V6C4.25 3.77 4.25 1.25 9 1.25H15C19.75 1.25 19.75 3.77 19.75 6V12C19.75 12.41 19.41 12.75 19 12.75Z"
          fill={fill}
        />
        <path
          d="M13.8798 9.97998H10.5498C10.1398 9.97998 9.7998 9.63998 9.7998 9.22998C9.7998 8.81998 10.1398 8.47998 10.5498 8.47998H13.8798C14.2898 8.47998 14.6298 8.81998 14.6298 9.22998C14.6298 9.63998 14.2998 9.97998 13.8798 9.97998Z"
          fill={fill}
        />
        <path
          d="M14.7202 6.97998H9.72021C9.31021 6.97998 8.97021 6.63998 8.97021 6.22998C8.97021 5.81998 9.31021 5.47998 9.72021 5.47998H14.7202C15.1302 5.47998 15.4702 5.81998 15.4702 6.22998C15.4702 6.63998 15.1402 6.97998 14.7202 6.97998Z"
          fill={fill}
        />
      </svg>
    ) : (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 22.75H8C2.25 22.75 2.25 19.7 2.25 17V16C2.25 13.77 2.25 11.25 7 11.25C8.19 11.25 8.63 11.54 9.25 12C9.28 12.03 9.32 12.05 9.35 12.09L10.37 13.17C11.23 14.08 12.79 14.08 13.65 13.17L14.67 12.09C14.7 12.06 14.73 12.03 14.77 12C15.39 11.53 15.83 11.25 17.02 11.25C21.77 11.25 21.77 13.77 21.77 16V17C21.75 20.82 19.82 22.75 16 22.75ZM7 12.75C3.75 12.75 3.75 13.77 3.75 16V17C3.75 19.74 3.75 21.25 8 21.25H16C18.98 21.25 20.25 19.98 20.25 17V16C20.25 13.77 20.25 12.75 17 12.75C16.28 12.75 16.13 12.84 15.7 13.16L14.73 14.19C14.01 14.95 13.04 15.37 12 15.37C10.96 15.37 9.99 14.95 9.27 14.19L8.3 13.16C7.87 12.84 7.72 12.75 7 12.75Z"
          fill={fill}
        />
        <path
          d="M19 12.75C18.59 12.75 18.25 12.41 18.25 12V6C18.25 3.77 18.25 2.75 15 2.75H9C5.75 2.75 5.75 3.77 5.75 6V12C5.75 12.41 5.41 12.75 5 12.75C4.59 12.75 4.25 12.41 4.25 12V6C4.25 3.77 4.25 1.25 9 1.25H15C19.75 1.25 19.75 3.77 19.75 6V12C19.75 12.41 19.41 12.75 19 12.75Z"
          fill={fill}
        />
        <path
          d="M13.8798 9.97998H10.5498C10.1398 9.97998 9.7998 9.63998 9.7998 9.22998C9.7998 8.81998 10.1398 8.47998 10.5498 8.47998H13.8798C14.2898 8.47998 14.6298 8.81998 14.6298 9.22998C14.6298 9.63998 14.2998 9.97998 13.8798 9.97998Z"
          fill={fill}
        />
        <path
          d="M14.7202 6.97998H9.72021C9.31021 6.97998 8.97021 6.63998 8.97021 6.22998C8.97021 5.81998 9.31021 5.47998 9.72021 5.47998H14.7202C15.1302 5.47998 15.4702 5.81998 15.4702 6.22998C15.4702 6.63998 15.1402 6.97998 14.7202 6.97998Z"
          fill={fill}
        />
      </svg>
    ),
  Archive: ({ fill, active, ...props }) =>
    active ? (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        fill="none"
      >
        <path
          d="M 16 22.75 L 8 22.75 C 4.35 22.75 2.25 20.65 2.25 17 L 2.25 7 C 2.25 3.35 4.35 1.25 8 1.25 L 16 1.25 C 19.65 1.25 21.75 3.35 21.75 7 L 21.75 17 C 21.75 20.65 19.65 22.75 16 22.75 Z"
          fill={fill}
        />
        <path
          d="M 8 2.75 C 5.14 2.75 3.75 4.14 3.75 7 L 3.75 17 C 3.75 19.86 5.14 21.25 8 21.25 L 16 21.25 C 18.86 21.25 20.25 19.86 20.25 17 L 20.25 7 C 20.25 4.14 18.86 2.75 16 2.75 L 8 2.75 Z"
          fill={fill}
        />
        <path
          d="M 9 11.11 C 8.83 11.11 8.66 11.08 8.5 11.01 C 8.04 10.81 7.75 10.36 7.75 9.870000000000001 L 7.75 2 C 7.75 1.5899999999999999 8.09 1.25 8.5 1.25 L 15.5 1.25 C 15.91 1.25 16.25 1.5899999999999999 16.25 2 L 16.25 9.85999 C 16.25 10.36 15.96 10.81 15.5 11 C 15.05 11.2 14.52 11.11 14.15 10.77 L 12 8.79999 L 9.84998 10.78 C 9.60998 11 9.31 11.11 9 11.11 Z"
          fill="#fff"
        />
        <path
          d="M 12 7.21002 C 12.3 7.21002 12.61 7.31998 12.85 7.53998 L 14.75 9.28998 L 14.75 2.75 L 9.25 2.75 L 9.25 9.28998 L 11.15 7.53998 C 11.39 7.31998 11.7 7.21002 12 7.21002 Z"
          fill={fill}
        />
        <path
          d="M17.5 14.75H13.25C12.84 14.75 12.5 14.41 12.5 14C12.5 13.59 12.84 13.25 13.25 13.25H17.5C17.91 13.25 18.25 13.59 18.25 14C18.25 14.41 17.91 14.75 17.5 14.75Z"
          fill="#fff"
        />
        <path
          d="M17.5 18.75H9C8.59 18.75 8.25 18.41 8.25 18C8.25 17.59 8.59 17.25 9 17.25H17.5C17.91 17.25 18.25 17.59 18.25 18C18.25 18.41 17.91 18.75 17.5 18.75Z"
          fill="#fff"
        />
      </svg>
    ) : (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V7C2.25 3.35 4.35 1.25 8 1.25H16C19.65 1.25 21.75 3.35 21.75 7V17C21.75 20.65 19.65 22.75 16 22.75ZM8 2.75C5.14 2.75 3.75 4.14 3.75 7V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V7C20.25 4.14 18.86 2.75 16 2.75H8Z"
          fill="#C7C9D9"
        />
        <path
          d="M9 11.11C8.83 11.11 8.66 11.08 8.5 11.01C8.04 10.81 7.75 10.36 7.75 9.87V2C7.75 1.59 8.09 1.25 8.5 1.25H15.5C15.91 1.25 16.25 1.59 16.25 2V9.85999C16.25 10.36 15.96 10.81 15.5 11C15.05 11.2 14.52 11.11 14.15 10.77L12 8.79999L9.84998 10.78C9.60998 11 9.31 11.11 9 11.11ZM12 7.21002C12.3 7.21002 12.61 7.31998 12.85 7.53998L14.75 9.28998V2.75H9.25V9.28998L11.15 7.53998C11.39 7.31998 11.7 7.21002 12 7.21002Z"
          fill="#C7C9D9"
        />
        <path
          d="M17.5 14.75H13.25C12.84 14.75 12.5 14.41 12.5 14C12.5 13.59 12.84 13.25 13.25 13.25H17.5C17.91 13.25 18.25 13.59 18.25 14C18.25 14.41 17.91 14.75 17.5 14.75Z"
          fill="#C7C9D9"
        />
        <path
          d="M17.5 18.75H9C8.59 18.75 8.25 18.41 8.25 18C8.25 17.59 8.59 17.25 9 17.25H17.5C17.91 17.25 18.25 17.59 18.25 18C18.25 18.41 17.91 18.75 17.5 18.75Z"
          fill="#C7C9D9"
        />
      </svg>
    ),
  Favourite: ({ fill, active, ...props }) =>
    active ? (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M 12 21.6501 C 11.69 21.6501 11.39 21.6101 11.14 21.5201 C 7.32 20.2101 1.25 15.5601 1.25 8.6901 C 1.25 5.1901 4.08 2.3501 7.5600000000000005 2.3501 C 9.25 2.3501 10.83 3.0101 12 4.1901 C 13.17 3.0101 14.75 2.3501 16.44 2.3501 C 19.92 2.3501 22.75 5.2001 22.75 8.6901 C 22.75 15.5701 16.68 20.2101 12.86 21.5201 C 12.61 21.6101 12.31 21.6501 12 21.6501 Z"
          fill={fill}
        />
      </svg>
    ) : (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 21.6501C11.69 21.6501 11.39 21.6101 11.14 21.5201C7.32 20.2101 1.25 15.5601 1.25 8.6901C1.25 5.1901 4.08 2.3501 7.56 2.3501C9.25 2.3501 10.83 3.0101 12 4.1901C13.17 3.0101 14.75 2.3501 16.44 2.3501C19.92 2.3501 22.75 5.2001 22.75 8.6901C22.75 15.5701 16.68 20.2101 12.86 21.5201C12.61 21.6101 12.31 21.6501 12 21.6501ZM7.56 3.8501C4.91 3.8501 2.75 6.0201 2.75 8.6901C2.75 15.5201 9.32 19.3201 11.63 20.1101C11.81 20.1701 12.2 20.1701 12.38 20.1101C14.68 19.3201 21.26 15.5301 21.26 8.6901C21.26 6.0201 19.1 3.8501 16.45 3.8501C14.93 3.8501 13.52 4.5601 12.61 5.7901C12.33 6.1701 11.69 6.1701 11.41 5.7901C10.48 4.5501 9.08 3.8501 7.56 3.8501Z"
          fill={fill}
        />
      </svg>
    ),
  Orders: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.6201 9.62012H12.3701C11.9601 9.62012 11.6201 9.28012 11.6201 8.87012C11.6201 8.46012 11.9601 8.12012 12.3701 8.12012H17.6201C18.0301 8.12012 18.3701 8.46012 18.3701 8.87012C18.3701 9.28012 18.0401 9.62012 17.6201 9.62012Z"
        fill={fill}
      />
      <path
        d="M7.12006 10.3798C6.93006 10.3798 6.74006 10.3098 6.59006 10.1598L5.84006 9.40982C5.55006 9.11982 5.55006 8.63982 5.84006 8.34982C6.13006 8.05982 6.61006 8.05982 6.90006 8.34982L7.12006 8.56982L8.84006 6.84982C9.13006 6.55982 9.61006 6.55982 9.90006 6.84982C10.1901 7.13982 10.1901 7.61982 9.90006 7.90982L7.65006 10.1598C7.51006 10.2998 7.32006 10.3798 7.12006 10.3798Z"
        fill={fill}
      />
      <path
        d="M17.6201 16.6201H12.3701C11.9601 16.6201 11.6201 16.2801 11.6201 15.8701C11.6201 15.4601 11.9601 15.1201 12.3701 15.1201H17.6201C18.0301 15.1201 18.3701 15.4601 18.3701 15.8701C18.3701 16.2801 18.0401 16.6201 17.6201 16.6201Z"
        fill={fill}
      />
      <path
        d="M7.12006 17.3798C6.93006 17.3798 6.74006 17.3098 6.59006 17.1598L5.84006 16.4098C5.55006 16.1198 5.55006 15.6398 5.84006 15.3498C6.13006 15.0598 6.61006 15.0598 6.90006 15.3498L7.12006 15.5698L8.84006 13.8498C9.13006 13.5598 9.61006 13.5598 9.90006 13.8498C10.1901 14.1398 10.1901 14.6198 9.90006 14.9098L7.65006 17.1598C7.51006 17.2998 7.32006 17.3798 7.12006 17.3798Z"
        fill={fill}
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill={fill}
      />
    </svg>
  ),
  Logout: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.24 22.27H15.11C10.67 22.27 8.53002 20.52 8.16002 16.6C8.12002 16.19 8.42002 15.82 8.84002 15.78C9.24002 15.74 9.62002 16.05 9.66002 16.46C9.95002 19.6 11.43 20.77 15.12 20.77H15.25C19.32 20.77 20.76 19.33 20.76 15.26V8.73998C20.76 4.66998 19.32 3.22998 15.25 3.22998H15.12C11.41 3.22998 9.93002 4.41998 9.66002 7.61998C9.61002 8.02998 9.26002 8.33998 8.84002 8.29998C8.42002 8.26998 8.12001 7.89998 8.15001 7.48998C8.49001 3.50998 10.64 1.72998 15.11 1.72998H15.24C20.15 1.72998 22.25 3.82998 22.25 8.73998V15.26C22.25 20.17 20.15 22.27 15.24 22.27Z"
        fill={fill}
      />
      <path
        d="M15.0001 12.75H3.62012C3.21012 12.75 2.87012 12.41 2.87012 12C2.87012 11.59 3.21012 11.25 3.62012 11.25H15.0001C15.4101 11.25 15.7501 11.59 15.7501 12C15.7501 12.41 15.4101 12.75 15.0001 12.75Z"
        fill={fill}
      />
      <path
        d="M5.84994 16.0998C5.65994 16.0998 5.46994 16.0298 5.31994 15.8798L1.96994 12.5298C1.67994 12.2398 1.67994 11.7598 1.96994 11.4698L5.31994 8.11984C5.60994 7.82984 6.08994 7.82984 6.37994 8.11984C6.66994 8.40984 6.66994 8.88984 6.37994 9.17984L3.55994 11.9998L6.37994 14.8198C6.66994 15.1098 6.66994 15.5898 6.37994 15.8798C6.23994 16.0298 6.03994 16.0998 5.84994 16.0998Z"
        fill={fill}
      />
    </svg>
  ),
  Trash: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.0002 6.73046C20.9802 6.73046 20.9502 6.73046 20.9202 6.73046C15.6302 6.20046 10.3502 6.00046 5.12016 6.53046L3.08016 6.73046C2.66016 6.77046 2.29016 6.47046 2.25016 6.05046C2.21016 5.63046 2.51016 5.27046 2.92016 5.23046L4.96016 5.03046C10.2802 4.49046 15.6702 4.70046 21.0702 5.23046C21.4802 5.27046 21.7802 5.64046 21.7402 6.05046C21.7102 6.44046 21.3802 6.73046 21.0002 6.73046Z"
        fill={fill}
      />
      <path
        d="M8.49977 5.72C8.45977 5.72 8.41977 5.72 8.36977 5.71C7.96977 5.64 7.68977 5.25 7.75977 4.85L7.97977 3.54C8.13977 2.58 8.35977 1.25 10.6898 1.25H13.3098C15.6498 1.25 15.8698 2.63 16.0198 3.55L16.2398 4.85C16.3098 5.26 16.0298 5.65 15.6298 5.71C15.2198 5.78 14.8298 5.5 14.7698 5.1L14.5498 3.8C14.4098 2.93 14.3798 2.76 13.3198 2.76H10.6998C9.63977 2.76 9.61977 2.9 9.46977 3.79L9.23977 5.09C9.17977 5.46 8.85977 5.72 8.49977 5.72Z"
        fill={fill}
      />
      <path
        d="M15.2099 22.7496H8.7899C5.2999 22.7496 5.1599 20.8196 5.0499 19.2596L4.3999 9.18959C4.3699 8.77959 4.6899 8.41959 5.0999 8.38959C5.5199 8.36959 5.8699 8.67959 5.8999 9.08959L6.5499 19.1596C6.6599 20.6796 6.6999 21.2496 8.7899 21.2496H15.2099C17.3099 21.2496 17.3499 20.6796 17.4499 19.1596L18.0999 9.08959C18.1299 8.67959 18.4899 8.36959 18.8999 8.38959C19.3099 8.41959 19.6299 8.76959 19.5999 9.18959L18.9499 19.2596C18.8399 20.8196 18.6999 22.7496 15.2099 22.7496Z"
        fill={fill}
      />
      <path
        d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
        fill={fill}
      />
      <path
        d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
        fill={fill}
      />
    </svg>
  ),
  Heart: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z"
        fill={fill}
      />
    </svg>
  ),
  Star: ({ fill, stroke, ...props }) => (
    <svg
      width={props.width ? props.width : "20"}
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6421 2.29976L14.239 5.49359C14.4568 5.93818 15.0375 6.36463 15.5274 6.44629L18.4218 6.92718C20.2728 7.23567 20.7083 8.57853 19.3745 9.90325L17.1243 12.1534C16.7433 12.5345 16.5346 13.2695 16.6525 13.7957L17.2967 16.5812C17.8048 18.7861 16.6344 19.639 14.6836 18.4867L11.9707 16.8807C11.4807 16.5903 10.6732 16.5903 10.1741 16.8807L7.4612 18.4867C5.5195 19.639 4.33996 18.777 4.84807 16.5812L5.49228 13.7957C5.61023 13.2695 5.40155 12.5345 5.02046 12.1534L2.77027 9.90325C1.44556 8.57853 1.872 7.23567 3.72297 6.92718L6.61738 6.44629C7.09827 6.36463 7.67896 5.93818 7.89672 5.49359L9.49364 2.29976C10.3647 0.566747 11.7801 0.566747 12.6421 2.29976Z"
        fill={fill}
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Prev: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0904 3.32998C15.2804 3.32998 15.4704 3.39998 15.6204 3.54998C15.9104 3.83998 15.9104 4.31998 15.6204 4.60998L9.10039 11.13C8.62039 11.61 8.62039 12.39 9.10039 12.87L15.6204 19.39C15.9104 19.68 15.9104 20.16 15.6204 20.45C15.3304 20.74 14.8504 20.74 14.5604 20.45L8.04039 13.93C7.53039 13.42 7.24039 12.73 7.24039 12C7.24039 11.27 7.52039 10.58 8.04039 10.07L14.5604 3.54998C14.7104 3.40998 14.9004 3.32998 15.0904 3.32998Z"
        fill="#292D32"
      />
    </svg>
  ),
  Next: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.90961 20.67C8.71961 20.67 8.52961 20.6 8.37961 20.45C8.08961 20.16 8.08961 19.68 8.37961 19.39L14.8996 12.87C15.3796 12.39 15.3796 11.61 14.8996 11.13L8.37961 4.61002C8.08961 4.32002 8.08961 3.84002 8.37961 3.55002C8.66961 3.26002 9.14961 3.26002 9.43961 3.55002L15.9596 10.07C16.4696 10.58 16.7596 11.27 16.7596 12C16.7596 12.73 16.4796 13.42 15.9596 13.93L9.43961 20.45C9.28961 20.59 9.09961 20.67 8.90961 20.67Z"
        fill="#292D32"
      />
    </svg>
  ),
  ArrowLeft: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="rotated"
      {...props}
    >
      <path
        d="M9.57043 18.8201C9.38043 18.8201 9.19043 18.7501 9.04043 18.6001L2.97043 12.5301C2.68043 12.2401 2.68043 11.7601 2.97043 11.4701L9.04043 5.40012C9.33043 5.11012 9.81043 5.11012 10.1004 5.40012C10.3904 5.69012 10.3904 6.17012 10.1004 6.46012L4.56043 12.0001L10.1004 17.5401C10.3904 17.8301 10.3904 18.3101 10.1004 18.6001C9.96043 18.7501 9.76043 18.8201 9.57043 18.8201Z"
        fill={fill}
      />
      <path
        d="M20.4999 12.75H3.66992C3.25992 12.75 2.91992 12.41 2.91992 12C2.91992 11.59 3.25992 11.25 3.66992 11.25H20.4999C20.9099 11.25 21.2499 11.59 21.2499 12C21.2499 12.41 20.9099 12.75 20.4999 12.75Z"
        fill={fill}
      />
    </svg>
  ),
  ArrowDown: ({ fill, ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9465 5.45337H7.79316H4.05317C3.41317 5.45337 3.09317 6.2267 3.5465 6.68004L6.99983 10.1334C7.55317 10.6867 8.45317 10.6867 9.0065 10.1334L10.3198 8.82003L12.4598 6.68004C12.9065 6.2267 12.5865 5.45337 11.9465 5.45337Z"
        fill="#8F90A6"
      />
    </svg>
  ),
  Search: ({ fill, ...props }) => (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.2136 34.3217C9.33502 34.3217 2.10645 27.0931 2.10645 18.2146C2.10645 9.33599 9.33502 2.10742 18.2136 2.10742C27.0922 2.10742 34.3207 9.33599 34.3207 18.2146C34.3207 27.0931 27.0922 34.3217 18.2136 34.3217ZM18.2136 4.46456C10.6236 4.46456 4.46359 10.6403 4.46359 18.2146C4.46359 25.7889 10.6236 31.9646 18.2136 31.9646C25.8036 31.9646 31.9636 25.7889 31.9636 18.2146C31.9636 10.6403 25.8036 4.46456 18.2136 4.46456Z"
        fill="white"
      />
      <path
        d="M34.714 35.893C34.4154 35.893 34.1168 35.783 33.8811 35.5473L30.7383 32.4045C30.2826 31.9488 30.2826 31.1945 30.7383 30.7388C31.194 30.283 31.9483 30.283 32.404 30.7388L35.5468 33.8816C36.0026 34.3373 36.0026 35.0916 35.5468 35.5473C35.3111 35.783 35.0126 35.893 34.714 35.893Z"
        fill="white"
      />
    </svg>
  ),
  ArrowDown2: ({ fill, ...props }) => (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 1.19005C14 1.49254 13.8855 1.79503 13.6401 2.03383L7.86503 7.65373C7.39059 8.11542 6.60532 8.11542 6.13088 7.65373L0.355828 2.03383C-0.11861 1.57214 -0.11861 0.80796 0.355828 0.346269C0.830265 -0.115423 1.61554 -0.115423 2.08998 0.346269L6.99795 5.12239L11.9059 0.346268C12.3804 -0.115424 13.1656 -0.115424 13.6401 0.346268C13.8855 0.569154 14 0.871641 14 1.19005Z"
        fill={fill}
      />
    </svg>
  ),
  VectorLeft: ({ fill, ...props }) => (
    <svg
      width="6"
      height="9"
      viewBox="0 0 6 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="rotated"
      {...props}
    >
      <path
        d="M4.2775 8.5575C4.0875 8.5575 3.8975 8.4875 3.7475 8.3375L0.2175 4.8075C-0.0725 4.5175 -0.0725 4.0375 0.2175 3.7475L3.7475 0.2175C4.0375 -0.0725 4.5175 -0.0725 4.8075 0.2175C5.0975 0.5075 5.0975 0.9875 4.8075 1.2775L1.8075 4.2775L4.8075 7.2775C5.0975 7.5675 5.0975 8.0475 4.8075 8.3375C4.6675 8.4875 4.4775 8.5575 4.2775 8.5575Z"
        fill="#292D32"
      />
    </svg>
  ),
  PinkLeft: ({ fill, ...props }) => (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.564 22.7404C11.3344 22.7404 11.1048 22.6558 10.9236 22.4745L3.58898 15.1399C3.23857 14.7895 3.23857 14.2095 3.58898 13.8591L10.9236 6.52453C11.274 6.17411 11.854 6.17411 12.2044 6.52453C12.5548 6.87495 12.5548 7.45495 12.2044 7.80536L5.51023 14.4995L12.2044 21.1937C12.5548 21.5441 12.5548 22.1241 12.2044 22.4745C12.0352 22.6558 11.7936 22.7404 11.564 22.7404Z"
        fill="#951B81"
      />
      <path
        d="M24.7708 15.4062H4.43457C3.93915 15.4062 3.52832 14.9954 3.52832 14.5C3.52832 14.0046 3.93915 13.5938 4.43457 13.5938H24.7708C25.2662 13.5938 25.6771 14.0046 25.6771 14.5C25.6771 14.9954 25.2662 15.4062 24.7708 15.4062Z"
        fill="#951B81"
      />
    </svg>
  ),
  PDF: ({ fill, ...props }) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.7497 20.8541H8.24967C3.27217 20.8541 1.14551 18.7274 1.14551 13.7499V8.24992C1.14551 3.27242 3.27217 1.14575 8.24967 1.14575H13.7497C18.7272 1.14575 20.8538 3.27242 20.8538 8.24992V13.7499C20.8538 18.7274 18.7272 20.8541 13.7497 20.8541ZM8.24967 2.52075C4.02384 2.52075 2.52051 4.02409 2.52051 8.24992V13.7499C2.52051 17.9758 4.02384 19.4791 8.24967 19.4791H13.7497C17.9755 19.4791 19.4788 17.9758 19.4788 13.7499V8.24992C19.4788 4.02409 17.9755 2.52075 13.7497 2.52075H8.24967Z"
        fill={fill}
      />
      <path
        d="M12.6134 16.2709H9.37755C8.36922 16.2709 7.57172 15.7759 7.12255 14.8776L6.30672 13.2367C6.11422 12.8426 5.72005 12.6042 5.28005 12.6042H1.82422C1.44839 12.6042 1.13672 12.2926 1.13672 11.9167C1.13672 11.5409 1.45755 11.2292 1.83339 11.2292H5.28005C6.24255 11.2292 7.10422 11.7609 7.53505 12.6226L8.35088 14.2634C8.56172 14.6851 8.90088 14.8959 9.37755 14.8959H12.6134C13.0534 14.8959 13.4476 14.6576 13.6401 14.2634L14.4559 12.6226C14.8867 11.7609 15.7484 11.2292 16.7109 11.2292H20.1392C20.5151 11.2292 20.8267 11.5409 20.8267 11.9167C20.8267 12.2926 20.5151 12.6042 20.1392 12.6042H16.7109C16.2709 12.6042 15.8767 12.8426 15.6842 13.2367L14.8684 14.8776C14.4376 15.7392 13.5759 16.2709 12.6134 16.2709Z"
        fill={fill}
      />
      <path
        d="M12.5304 7.10425H9.47792C9.09292 7.10425 8.78125 6.79258 8.78125 6.41675C8.78125 6.04091 9.09292 5.72925 9.46875 5.72925H12.5212C12.8971 5.72925 13.2087 6.04091 13.2087 6.41675C13.2087 6.79258 12.9062 7.10425 12.5304 7.10425Z"
        fill={fill}
      />
      <path
        d="M13.2913 9.85425H8.70801C8.33217 9.85425 8.02051 9.54258 8.02051 9.16675C8.02051 8.79091 8.33217 8.47925 8.70801 8.47925H13.2913C13.6672 8.47925 13.9788 8.79091 13.9788 9.16675C13.9788 9.54258 13.6672 9.85425 13.2913 9.85425Z"
        fill={fill}
      />
    </svg>
  ),
  Book: ({ fill, small, ...props }) => (
    <svg
      height={small === true ? "24" : "60"}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9997 20.24C10.7247 20.24 10.4497 20.1758 10.2205 20.0475C8.50634 19.1125 5.49051 18.1225 3.60217 17.875L3.33634 17.8383C2.13551 17.6916 1.14551 16.5641 1.14551 15.345V4.27163C1.14551 3.54747 1.42967 2.88747 1.95217 2.4108C2.47467 1.93413 3.15301 1.70497 3.86801 1.76913C5.88467 1.92497 8.92801 2.9333 10.6513 4.01497L10.8713 4.1433C10.9355 4.17997 11.073 4.17997 11.128 4.15247L11.2747 4.0608C12.998 2.97913 16.0413 1.95247 18.0672 1.7783C18.0855 1.7783 18.1588 1.7783 18.1772 1.7783C18.8463 1.71413 19.5338 1.95247 20.0472 2.42913C20.5697 2.9058 20.8538 3.5658 20.8538 4.28997V15.3541C20.8538 16.5825 19.8638 17.7008 18.6538 17.8475L18.3513 17.8841C16.463 18.1316 13.438 19.1308 11.7605 20.0566C11.5405 20.185 11.2747 20.24 10.9997 20.24ZM3.64801 3.13497C3.35467 3.13497 3.08884 3.2358 2.87801 3.4283C2.64884 3.63913 2.52051 3.94163 2.52051 4.27163V15.345C2.52051 15.8858 2.98801 16.4083 3.51051 16.4816L3.78551 16.5183C5.84801 16.7933 9.01051 17.8291 10.8438 18.8283C10.9263 18.865 11.0455 18.8741 11.0913 18.8558C12.9247 17.8383 16.1055 16.7933 18.1772 16.5183L18.4888 16.4816C19.0113 16.4175 19.4788 15.8858 19.4788 15.345V4.2808C19.4788 3.94163 19.3505 3.6483 19.1213 3.4283C18.883 3.21747 18.5805 3.11663 18.2413 3.13497C18.223 3.13497 18.1497 3.13497 18.1313 3.13497C16.3805 3.2908 13.5572 4.23497 12.0172 5.19747L11.8705 5.2983C11.3663 5.60997 10.6513 5.60997 10.1655 5.30747L9.94551 5.17913C8.37801 4.21663 5.55467 3.28163 3.75801 3.13497C3.72134 3.13497 3.68467 3.13497 3.64801 3.13497Z"
        fill={fill}
      />
      <path
        d="M11 19.47C10.6242 19.47 10.3125 19.1583 10.3125 18.7825V5.03247C10.3125 4.65664 10.6242 4.34497 11 4.34497C11.3758 4.34497 11.6875 4.65664 11.6875 5.03247V18.7825C11.6875 19.1675 11.3758 19.47 11 19.47Z"
        fill={fill}
      />
      <path
        d="M7.10449 8.46997H5.04199C4.66616 8.46997 4.35449 8.1583 4.35449 7.78247C4.35449 7.40664 4.66616 7.09497 5.04199 7.09497H7.10449C7.48033 7.09497 7.79199 7.40664 7.79199 7.78247C7.79199 8.1583 7.48033 8.46997 7.10449 8.46997Z"
        fill={fill}
      />
      <path
        d="M7.79199 11.22H5.04199C4.66616 11.22 4.35449 10.9083 4.35449 10.5325C4.35449 10.1566 4.66616 9.84497 5.04199 9.84497H7.79199C8.16782 9.84497 8.47949 10.1566 8.47949 10.5325C8.47949 10.9083 8.16782 11.22 7.79199 11.22Z"
        fill={fill}
      />
    </svg>
  ),
  Audio: ({ fill, ...props }) => (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.42577 17.971C2.57327 17.971 1.00577 16.4035 1.00577 14.551V9.67428C0.958268 7.37053 1.8212 5.19347 3.42037 3.55472C5.01953 1.92388 7.17286 1.0293 9.47661 1.0293C14.1949 1.0293 18.0266 4.86888 18.0266 9.58721V14.4639C18.0266 16.3481 16.4908 17.8839 14.6066 17.8839C12.7225 17.8839 11.1866 16.3481 11.1866 14.4639V12.2393C11.1866 11.1072 12.1049 10.1889 13.237 10.1889C14.3691 10.1889 15.2874 11.1072 15.2874 12.2393V14.638C15.2874 14.9626 15.0183 15.2318 14.6937 15.2318C14.3691 15.2318 14.0999 14.9626 14.0999 14.638V12.2393C14.0999 11.701 13.6645 11.3764 13.237 11.3764C12.6987 11.3764 12.3741 11.8118 12.3741 12.2393V14.4639C12.3741 15.6752 13.3954 16.6964 14.6066 16.6964C15.8179 16.6964 16.8391 15.6752 16.8391 14.4639V9.58721C16.8391 5.52596 13.5379 2.2168 9.47661 2.2168C7.48953 2.2168 5.64496 2.98471 4.26746 4.38596C2.88996 5.78721 2.15368 7.66348 2.19327 9.65848V14.5431C2.19327 15.7543 3.21452 16.7756 4.42577 16.7756C5.63702 16.7756 6.65828 15.7543 6.65828 14.5431V12.3185C6.65828 11.7801 6.22287 11.4555 5.79537 11.4555C5.25703 11.4555 4.93245 11.891 4.93245 12.3185V14.6301C4.93245 14.9547 4.66329 15.2239 4.3387 15.2239C4.01412 15.2239 3.74495 14.9547 3.74495 14.6301V12.3185C3.74495 11.1706 4.64745 10.268 5.79537 10.268C6.92745 10.268 7.84578 11.1864 7.84578 12.3185V14.5431C7.84578 16.4351 6.30994 17.971 4.42577 17.971Z"
        fill={fill}
      />
      <path
        d="M10.4338 9.38908C10.1172 9.38908 9.83216 9.21495 9.69758 8.92995L8.54965 6.64202L8.21716 7.25949C8.03508 7.59991 7.67092 7.81367 7.283 7.81367H6.70508C6.38049 7.81367 6.11133 7.5445 6.11133 7.21992C6.11133 6.89534 6.38049 6.62617 6.70508 6.62617H7.21173L7.83716 5.47032C7.98757 5.20115 8.26465 5.05866 8.5734 5.03491C8.88215 5.03491 9.15924 5.217 9.30174 5.48617L10.4338 7.75032L10.703 7.20407C10.8851 6.8399 11.2413 6.61825 11.653 6.61825H12.2942C12.6188 6.61825 12.888 6.88741 12.888 7.212C12.888 7.53658 12.6188 7.80575 12.2942 7.80575H11.7322L11.1701 8.92202C11.0276 9.21494 10.7505 9.38908 10.4338 9.38908Z"
        fill={fill}
      />
    </svg>
  ),
  SMS: ({ fill, ...props }) => (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.834 21.3418H7.83398C4.18398 21.3418 2.08398 19.2418 2.08398 15.5918V8.5918C2.08398 4.9418 4.18398 2.8418 7.83398 2.8418H17.834C21.484 2.8418 23.584 4.9418 23.584 8.5918V15.5918C23.584 19.2418 21.484 21.3418 17.834 21.3418ZM7.83398 4.3418C4.97398 4.3418 3.58398 5.7318 3.58398 8.5918V15.5918C3.58398 18.4518 4.97398 19.8418 7.83398 19.8418H17.834C20.694 19.8418 22.084 18.4518 22.084 15.5918V8.5918C22.084 5.7318 20.694 4.3418 17.834 4.3418H7.83398Z"
        fill="#292D32"
      />
      <path
        d="M12.8338 12.9618C11.9938 12.9618 11.1438 12.7018 10.4938 12.1718L7.36376 9.67177C7.04376 9.41177 6.98377 8.94177 7.24377 8.62177C7.50377 8.30177 7.97377 8.24177 8.29377 8.50177L11.4238 11.0018C12.1838 11.6118 13.4738 11.6118 14.2338 11.0018L17.3638 8.50177C17.6838 8.24177 18.1638 8.29177 18.4138 8.62177C18.6738 8.94177 18.6238 9.42177 18.2938 9.67177L15.1638 12.1718C14.5238 12.7018 13.6738 12.9618 12.8338 12.9618Z"
        fill="#292D32"
      />
    </svg>
  ),
  Language: ({ fill, ...props }) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5741 8.90088H6.42578C6.04995 8.90088 5.73828 8.58921 5.73828 8.21338C5.73828 7.83755 6.04995 7.52588 6.42578 7.52588H15.5741C15.9499 7.52588 16.2616 7.83755 16.2616 8.21338C16.2616 8.58921 15.9499 8.90088 15.5741 8.90088Z"
        fill="#8F90A6"
      />
      <path
        d="M11 8.90083C10.6242 8.90083 10.3125 8.58917 10.3125 8.21333V6.67334C10.3125 6.29751 10.6242 5.98584 11 5.98584C11.3758 5.98584 11.6875 6.29751 11.6875 6.67334V8.21333C11.6875 8.58917 11.3758 8.90083 11 8.90083Z"
        fill="#8F90A6"
      />
      <path
        d="M6.41699 16.014C6.04116 16.014 5.72949 15.7023 5.72949 15.3265C5.72949 14.9506 6.04116 14.639 6.41699 14.639C9.82699 14.639 12.6045 11.7515 12.6045 8.19482C12.6045 7.81899 12.9162 7.50732 13.292 7.50732C13.6678 7.50732 13.9795 7.81899 13.9795 8.19482C13.9795 12.5123 10.5878 16.014 6.41699 16.014Z"
        fill="#8F90A6"
      />
      <path
        d="M15.5838 16.0141C13.778 16.0141 12.1005 15.1158 10.8721 13.475C10.643 13.1725 10.7071 12.7417 11.0096 12.5125C11.3121 12.2834 11.743 12.3475 11.9721 12.65C12.9438 13.9333 14.2271 14.6391 15.593 14.6391C15.9688 14.6391 16.2805 14.9508 16.2805 15.3266C16.2805 15.7025 15.9596 16.0141 15.5838 16.0141Z"
        fill="#8F90A6"
      />
      <path
        d="M10.9997 20.8541C5.56384 20.8541 1.14551 16.4358 1.14551 10.9999C1.14551 5.56409 5.56384 1.14575 10.9997 1.14575C16.4355 1.14575 20.8538 5.56409 20.8538 10.9999C20.8538 16.4358 16.4355 20.8541 10.9997 20.8541ZM10.9997 2.52075C6.32467 2.52075 2.52051 6.32492 2.52051 10.9999C2.52051 15.6749 6.32467 19.4791 10.9997 19.4791C15.6747 19.4791 19.4788 15.6749 19.4788 10.9999C19.4788 6.32492 15.6747 2.52075 10.9997 2.52075Z"
        fill="#8F90A6"
      />
    </svg>
  ),
  BookMark: ({ fill, ...props }) => (
    <svg
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.7502 20.8543H8.25016C3.27266 20.8543 1.146 18.7277 1.146 13.7502V8.25016C1.146 3.27266 3.27266 1.146 8.25016 1.146H13.7502C18.7277 1.146 20.8543 3.27266 20.8543 8.25016V13.7502C20.8543 18.7277 18.7277 20.8543 13.7502 20.8543ZM8.25016 2.521C4.02433 2.521 2.521 4.02433 2.521 8.25016V13.7502C2.521 17.976 4.02433 19.4793 8.25016 19.4793H13.7502C17.976 19.4793 19.4793 17.976 19.4793 13.7502V8.25016C19.4793 4.02433 17.976 2.521 13.7502 2.521H8.25016Z"
        fill={fill}
      />
      <path
        d="M7.9565 14.0526C7.5715 14.0526 7.214 13.961 6.90234 13.7868C6.1415 13.356 5.729 12.5035 5.729 11.3851V2.23682C5.729 1.86098 6.04067 1.54932 6.4165 1.54932C6.79234 1.54932 7.104 1.86098 7.104 2.23682V11.3851C7.104 11.981 7.27817 12.421 7.58067 12.586C7.9015 12.7693 8.3965 12.6776 8.93734 12.3568L10.1473 11.6326C10.6423 11.3393 11.3482 11.3393 11.8432 11.6326L13.0532 12.3568C13.6032 12.6868 14.0982 12.7693 14.4098 12.586C14.7123 12.4118 14.8865 11.9718 14.8865 11.3851V2.23682C14.8865 1.86098 15.1982 1.54932 15.574 1.54932C15.9498 1.54932 16.2615 1.86098 16.2615 2.23682V11.3851C16.2615 12.5035 15.849 13.356 15.0882 13.7868C14.3273 14.2176 13.3282 14.126 12.3473 13.5393L11.1373 12.8151C11.0823 12.7785 10.9082 12.7785 10.8532 12.8151L9.64317 13.5393C9.07484 13.8785 8.48817 14.0526 7.9565 14.0526Z"
        fill={fill}
      />
      <path
        d="M13.7502 20.8543H8.25016C3.27266 20.8543 1.146 18.7277 1.146 13.7502V8.25016C1.146 3.27266 3.27266 1.146 8.25016 1.146H13.7502C18.7277 1.146 20.8543 3.27266 20.8543 8.25016V13.7502C20.8543 18.7277 18.7277 20.8543 13.7502 20.8543ZM8.25016 2.521C4.02433 2.521 2.521 4.02433 2.521 8.25016V13.7502C2.521 17.976 4.02433 19.4793 8.25016 19.4793H13.7502C17.976 19.4793 19.4793 17.976 19.4793 13.7502V8.25016C19.4793 4.02433 17.976 2.521 13.7502 2.521H8.25016Z"
        fill={fill}
      />
      <path
        d="M7.9565 14.0526C7.5715 14.0526 7.214 13.961 6.90234 13.7868C6.1415 13.356 5.729 12.5035 5.729 11.3851V2.23682C5.729 1.86098 6.04067 1.54932 6.4165 1.54932C6.79234 1.54932 7.104 1.86098 7.104 2.23682V11.3851C7.104 11.981 7.27817 12.421 7.58067 12.586C7.9015 12.7693 8.3965 12.6776 8.93734 12.3568L10.1473 11.6326C10.6423 11.3393 11.3482 11.3393 11.8432 11.6326L13.0532 12.3568C13.6032 12.6868 14.0982 12.7693 14.4098 12.586C14.7123 12.4118 14.8865 11.9718 14.8865 11.3851V2.23682C14.8865 1.86098 15.1982 1.54932 15.574 1.54932C15.9498 1.54932 16.2615 1.86098 16.2615 2.23682V11.3851C16.2615 12.5035 15.849 13.356 15.0882 13.7868C14.3273 14.2176 13.3282 14.126 12.3473 13.5393L11.1373 12.8151C11.0823 12.7785 10.9082 12.7785 10.8532 12.8151L9.64317 13.5393C9.07484 13.8785 8.48817 14.0526 7.9565 14.0526Z"
        fill={fill}
      />
    </svg>
  ),
  Chat: ({ fill, ...props }) => (
    <svg
      width="35"
      height="38"
      viewBox="0 0 35 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.4073 37.5425C34.4073 37.5425 28.7385 35.3885 24.1521 33.6629H4.86447C2.58087 33.6629 0.730469 31.7669 0.730469 29.4293V4.61326C0.730469 2.27686 2.58087 0.380859 4.86447 0.380859H30.2709C32.5545 0.380859 34.4061 2.27686 34.4061 4.61326V25.9865L34.4073 25.9853V37.5425ZM29.4297 23.6273C29.0337 23.1545 28.3365 23.1005 27.8757 23.5049C27.8397 23.5361 24.2493 26.6201 17.5665 26.6201C10.9689 26.6201 7.32327 23.5577 7.25727 23.5025C6.79527 23.0993 6.10167 23.1557 5.70567 23.6273C5.30847 24.1013 5.36367 24.8129 5.82567 25.2197C5.99727 25.3685 10.0809 28.8773 17.5665 28.8773C25.0557 28.8773 29.1405 25.3685 29.3097 25.2197C29.7717 24.8129 29.8269 24.1013 29.4297 23.6273Z"
        fill="white"
      />
    </svg>
  ),
  Discord: ({ fill, ...props }) => (
    <svg
      width="118"
      height="91"
      viewBox="0 0 118 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.108 8.43568C25.629 4.9848 33.694 2.44229 42.1266 0.986085C42.2801 0.957991 42.4335 1.02823 42.5126 1.1687C43.5498 3.01354 44.6987 5.42025 45.5033 7.31192C54.573 5.95404 63.5963 5.95404 72.48 7.31192C73.2846 5.37811 74.4753 3.01354 75.5172 1.1687C75.5962 1.03291 75.7497 0.962673 75.9032 0.986085C84.3311 2.43761 92.3962 4.98012 99.9217 8.43568C99.9868 8.46377 100.043 8.51059 100.08 8.57147C115.377 31.4259 119.568 53.7185 117.512 75.7348C117.503 75.8425 117.443 75.9456 117.359 76.0111C107.266 83.4232 97.4892 87.923 87.8939 90.9056C87.7404 90.9524 87.5776 90.8962 87.4799 90.7698C85.2101 87.6701 83.1869 84.4019 81.452 80.965C81.3497 80.7637 81.4474 80.5249 81.6567 80.4453C84.866 79.2279 87.9218 77.7436 90.8613 76.0579C91.0938 75.9221 91.1125 75.5897 90.8985 75.4305C90.2799 74.9669 89.6613 74.4847 89.0706 73.9977C88.9636 73.9087 88.8148 73.89 88.6892 73.9462C69.3776 82.763 48.4707 82.763 29.3871 73.9462C29.2615 73.8853 29.1127 73.9041 29.001 73.993C28.4103 74.48 27.7917 74.9669 27.1685 75.4305C26.9545 75.5897 26.9685 75.9221 27.201 76.0579C30.1406 77.7763 33.1964 79.2279 36.4103 80.4406C36.6196 80.5202 36.7126 80.7637 36.6103 80.965C34.8382 84.3972 32.815 87.6654 30.5871 90.7651C30.494 90.8962 30.3266 90.9524 30.1731 90.9056C20.5313 87.923 10.7546 83.4232 0.661591 76.0111C0.573219 75.9456 0.517403 75.8472 0.508102 75.7395C-1.95235 50.2864 4.62902 28.1764 17.9546 8.57615C17.9871 8.51059 18.0429 8.46377 18.108 8.43568ZM78.5683 62.3293C84.3822 62.3293 89.1729 56.9915 89.1729 50.4362C89.1729 43.8809 84.4753 38.5431 78.5683 38.5431C72.6148 38.5431 67.8707 43.9278 67.9637 50.4362C67.9637 56.9915 72.6614 62.3293 78.5683 62.3293ZM39.3591 62.3293C45.1731 62.3293 49.9638 56.9915 49.9638 50.4362C49.9638 43.8809 45.2661 38.5431 39.3591 38.5431C33.4057 38.5431 28.6615 43.9278 28.7545 50.4362C28.7545 56.9915 33.4057 62.3293 39.3591 62.3293Z"
        fill="white"
      />
    </svg>
  ),
  Facebook: ({ fill, ...props }) => (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.9375 0.0917969H7.0625C3.43813 0.0917969 0.5 3.02993 0.5 6.6543V35.5293C0.5 39.1537 3.43813 42.0918 7.0625 42.0918H35.9375C39.5619 42.0918 42.5 39.1537 42.5 35.5293V6.6543C42.5 3.02993 39.5619 0.0917969 35.9375 0.0917969Z"
        fill="#1877F2"
      />
      <path
        d="M32 21.0918C32 15.3168 27.275 10.5918 21.5 10.5918C15.725 10.5918 11 15.3168 11 21.0918C11 26.3418 14.8062 30.673 19.7937 31.4605V24.1105H17.1687V21.0918H19.7937V18.7293C19.7937 16.1043 21.3688 14.6605 23.7313 14.6605C24.9125 14.6605 26.0938 14.923 26.0938 14.923V17.548H24.7812C23.4688 17.548 23.075 18.3355 23.075 19.123V21.0918H25.9625L25.4375 24.1105H22.9438V31.5918C28.1938 30.8043 32 26.3418 32 21.0918Z"
        fill="white"
      />
    </svg>
  ),
  Telegram: ({ fill, ...props }) => (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.0625 0.0917969H7.1875C3.56313 0.0917969 0.625 3.02993 0.625 6.6543V35.5293C0.625 39.1537 3.56313 42.0918 7.1875 42.0918H36.0625C39.6869 42.0918 42.625 39.1537 42.625 35.5293V6.6543C42.625 3.02993 39.6869 0.0917969 36.0625 0.0917969Z"
        fill="#0088CC"
      />
      <path
        d="M11.2561 20.7089C16.8933 18.2529 20.6522 16.6338 22.5331 15.8515C27.9031 13.6179 29.019 13.2299 29.7463 13.2169C29.9063 13.2142 30.2639 13.2539 30.4956 13.4419C30.6912 13.6006 30.7451 13.815 30.7708 13.9655C30.7966 14.116 30.8287 14.4589 30.8032 14.7268C30.5122 17.7844 29.253 25.2045 28.6124 28.6291C28.3413 30.0782 27.8076 30.5641 27.2909 30.6116C26.1679 30.7149 25.3152 29.8695 24.2276 29.1565C22.5257 28.0409 21.5642 27.3464 19.9122 26.2578C18.0031 24.9997 19.2407 24.3082 20.3287 23.1781C20.6135 22.8824 25.5611 18.3821 25.6569 17.9738C25.6689 17.9228 25.68 17.7325 25.5669 17.632C25.4539 17.5315 25.287 17.5658 25.1666 17.5932C24.9959 17.6319 22.2771 19.4289 17.0101 22.9843C16.2384 23.5142 15.5394 23.7724 14.9131 23.7589C14.2227 23.744 12.8945 23.3685 11.9072 23.0476C10.6962 22.6539 9.73378 22.4458 9.81759 21.7773C9.86124 21.4291 10.3408 21.073 11.2561 20.7089Z"
        fill="white"
      />
    </svg>
  ),
  Whatsapp: ({ fill, ...props }) => (
    <svg
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.4375 0.0917969H6.5625C2.93813 0.0917969 0 3.02993 0 6.6543V35.5293C0 39.1537 2.93813 42.0918 6.5625 42.0918H35.4375C39.0619 42.0918 42 39.1537 42 35.5293V6.6543C42 3.02993 39.0619 0.0917969 35.4375 0.0917969Z"
        fill="#25D366"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.35 13.6105C26.3813 11.6418 23.7562 10.5918 21 10.5918C15.225 10.5918 10.5 15.3168 10.5 21.0918C10.5 22.9293 11.025 24.7668 11.9438 26.3418L10.5 31.5918L16.0125 30.148C17.5875 30.9355 19.2937 31.4605 21 31.4605C26.775 31.4605 31.5 26.7355 31.5 20.9605C31.5 18.2043 30.3188 15.5793 28.35 13.6105ZM21 29.7543C19.425 29.7543 17.85 29.3605 16.5375 28.573L16.275 28.4418L12.9937 29.3605L13.9125 26.2105L13.65 25.8168C12.7312 24.373 12.3375 22.798 12.3375 21.223C12.3375 16.498 16.275 12.5605 21 12.5605C23.3625 12.5605 25.4625 13.4793 27.1688 15.0543C28.875 16.7605 29.6625 18.8605 29.6625 21.223C29.6625 25.8168 25.8562 29.7543 21 29.7543ZM25.725 23.1918C25.4625 23.0605 24.15 22.4043 23.8875 22.4043C23.625 22.273 23.4937 22.273 23.3625 22.5355C23.2312 22.798 22.7063 23.323 22.575 23.5855C22.4438 23.7168 22.3125 23.7168 22.05 23.7168C21.7875 23.5855 21 23.323 19.95 22.4043C19.1625 21.748 18.6375 20.8293 18.5063 20.5668C18.375 20.3043 18.5063 20.173 18.6375 20.0418C18.7688 19.9105 18.9 19.7793 19.0312 19.648C19.1625 19.5168 19.1625 19.3855 19.2938 19.2543C19.425 19.123 19.2938 18.9918 19.2938 18.8605C19.2938 18.7293 18.7688 17.4168 18.5063 16.8918C18.375 16.498 18.1125 16.498 17.9813 16.498C17.85 16.498 17.7187 16.498 17.4562 16.498C17.325 16.498 17.0625 16.498 16.8 16.7605C16.5375 17.023 15.8813 17.6793 15.8813 18.9918C15.8813 20.3043 16.8 21.4855 16.9312 21.748C17.0625 21.8793 18.7687 24.6355 21.3937 25.6855C23.625 26.6043 24.0188 26.3418 24.5438 26.3418C25.0688 26.3418 26.1187 25.6855 26.25 25.1605C26.5125 24.5043 26.5125 23.9793 26.3813 23.9793C26.25 23.323 25.9875 23.323 25.725 23.1918Z"
        fill="white"
      />
    </svg>
  ),
  LinkedIn: ({ fill, ...props }) => (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.6875 0.0917969H6.8125C3.18813 0.0917969 0.25 3.02993 0.25 6.6543V35.5293C0.25 39.1537 3.18813 42.0918 6.8125 42.0918H35.6875C39.3119 42.0918 42.25 39.1537 42.25 35.5293V6.6543C42.25 3.02993 39.3119 0.0917969 35.6875 0.0917969Z"
        fill="#2867B2"
      />
      <path
        d="M15.475 31.5918H11.0125V17.548H15.475V31.5918ZM13.2438 15.5793C11.8 15.5793 10.75 14.5293 10.75 13.0855C10.75 11.6418 11.9313 10.5918 13.2438 10.5918C14.6875 10.5918 15.7375 11.6418 15.7375 13.0855C15.7375 14.5293 14.6875 15.5793 13.2438 15.5793ZM31.75 31.5918H27.2875V23.9793C27.2875 21.748 26.3687 21.0918 25.0562 21.0918C23.7437 21.0918 22.4312 22.1418 22.4312 24.1105V31.5918H17.9688V17.548H22.1687V19.5168C22.5625 18.598 24.1375 17.1543 26.3687 17.1543C28.8625 17.1543 31.4875 18.598 31.4875 22.9293V31.5918H31.75Z"
        fill="white"
      />
    </svg>
  ),
  Twitter: ({ fill, ...props }) => (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.3125 0.0917969H7.4375C3.81313 0.0917969 0.875 3.02993 0.875 6.6543V35.5293C0.875 39.1537 3.81313 42.0918 7.4375 42.0918H36.3125C39.9369 42.0918 42.875 39.1537 42.875 35.5293V6.6543C42.875 3.02993 39.9369 0.0917969 36.3125 0.0917969Z"
        fill="#1DA1F2"
      />
      <path
        d="M32.375 14.5293C31.5875 14.923 30.8 15.0543 29.8813 15.1855C30.8 14.6605 31.4562 13.873 31.7188 12.823C30.9312 13.348 30.0125 13.6105 28.9625 13.873C28.175 13.0855 26.9937 12.5605 25.8125 12.5605C23.0563 12.5605 20.9563 15.1855 21.6125 17.8105C18.0688 17.6793 14.9188 15.973 12.6875 13.348C11.5063 15.3168 12.1625 17.8105 14 19.123C13.3438 19.123 12.6875 18.8605 12.0312 18.598C12.0312 20.5668 13.475 22.4043 15.4438 22.9293C14.7875 23.0605 14.1313 23.1918 13.475 23.0605C14 24.7668 15.575 26.0793 17.5437 26.0793C15.9687 27.2605 13.6063 27.9168 11.375 27.6543C13.3438 28.8355 15.575 29.623 17.9375 29.623C25.9437 29.623 30.4062 22.9293 30.1437 16.7605C31.0625 16.2355 31.85 15.448 32.375 14.5293Z"
        fill="white"
      />
    </svg>
  ),
  Eye: ({ fill, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9999 16.33C9.60992 16.33 7.66992 14.39 7.66992 12C7.66992 9.61004 9.60992 7.67004 11.9999 7.67004C14.3899 7.67004 16.3299 9.61004 16.3299 12C16.3299 14.39 14.3899 16.33 11.9999 16.33ZM11.9999 9.17004C10.4399 9.17004 9.16992 10.44 9.16992 12C9.16992 13.56 10.4399 14.83 11.9999 14.83C13.5599 14.83 14.8299 13.56 14.8299 12C14.8299 10.44 13.5599 9.17004 11.9999 9.17004Z"
        fill={fill ? fill : "#8F90A6"}
      />
      <path
        d="M12.0001 21.02C8.24008 21.02 4.69008 18.82 2.25008 15C1.19008 13.35 1.19008 10.66 2.25008 8.99998C4.70008 5.17998 8.25008 2.97998 12.0001 2.97998C15.7501 2.97998 19.3001 5.17998 21.7401 8.99998C22.8001 10.65 22.8001 13.34 21.7401 15C19.3001 18.82 15.7501 21.02 12.0001 21.02ZM12.0001 4.47998C8.77008 4.47998 5.68008 6.41998 3.52008 9.80998C2.77008 10.98 2.77008 13.02 3.52008 14.19C5.68008 17.58 8.77008 19.52 12.0001 19.52C15.2301 19.52 18.3201 17.58 20.4801 14.19C21.2301 13.02 21.2301 10.98 20.4801 9.80998C18.3201 6.41998 15.2301 4.47998 12.0001 4.47998Z"
        fill={fill ? fill : "#8F90A6"}
      />
    </svg>
  ),
  CloseEye: ({ fill, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height="24"
      fill="none"
      {...props}
    >
      <path
        fill={fill ? fill : "#8F90A6"}
        d="M67.8,353.2L98,323c-21.2-19.2-39-41.8-52.6-67C88.4,176.8,168.2,128,256,128c11.5,0,23,0.9,34.4,2.5l36.1-36.1 c-23-6-46.7-9.1-70.5-9.1c-107.6,0-204.9,61.8-253.8,161.2c-2.9,5.9-2.9,12.9,0,18.8C18.4,298.5,40.6,328.3,67.8,353.2z"
      />
      <path
        fill={fill ? fill : "#8F90A6"}
        d="M410.1,132.1l95.6-95.7c8.3-8.3,8.3-21.8,0-30.2s-21.8-8.3-30.2,0c0,0,0,0,0,0L6.2,475.6
    c-8.3,8.3-8.3,21.8,0,30.2s21.8,8.3,30.2,0l0,0l104.2-104.2c36.2,16.6,75.6,25.2,115.4,25.1c107.6,0,204.9-61.8,253.8-161.2
    c2.9-5.9,2.9-12.9,0-18.8C486.3,198.8,451.7,159.8,410.1,132.1z M320,256c0,35.3-28.7,64-64,64c-9.5,0-18.9-2.1-27.6-6.2l85.3-85.3
    C317.9,237,320,246.5,320,256z M256,384c-28.3,0-56.3-5.1-82.7-15.1l24-24c49.1,32.5,115.3,19,147.7-30.1
    c23.6-35.6,23.6-81.9,0-117.6l34.2-34.2c36.8,22.8,66.9,54.9,87.5,93C423.6,335.2,343.8,384,256,384z"
      />
      <path
        fill={fill ? fill : "#8F90A6"}
        d="M149.3,256c0,4.9,0.3,9.8,1,14.6l120.3-120.3c-58.4-8.1-112.2,32.7-120.3,91C149.7,246.2,149.3,251.1,149.3,256
    z"
      />
    </svg>
  ),
  OpenEye: ({ fill, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height="24"
      fill="none"
      {...props}
    >
      <path
        fill={fill ? fill : "#8F90A6"}
        d="M250.8,427.2c-99.2,0-188.9-57-234.1-148.7c-2.7-5.5-2.7-11.9,0-17.4c45.1-91.8,134.9-148.7,234.1-148.7
	s188.9,57,234.1,148.7c2.7,5.5,2.7,11.9,0,17.4C439.7,370.2,350,427.2,250.8,427.2z M56.5,269.8c39.7,73.1,113.3,118.1,194.3,118.1
	s154.6-45,194.3-118.1c-39.7-73.1-113.3-118.1-194.3-118.1S96.2,196.7,56.5,269.8z"
      />
      <path
        fill={fill ? fill : "#8F90A6"}
        d="M250.8,368.1c-54.3,0-98.4-44-98.4-98.4c0-54.3,44-98.4,98.4-98.4s98.4,44,98.4,98.4
	C349.1,324.1,305.1,368.1,250.8,368.1z M250.8,210.7c-32.6,0-59,26.4-59,59s26.4,59,59,59s59-26.4,59-59
	C309.8,237.2,283.4,210.8,250.8,210.7z"
      />
    </svg>
  ),
  Cancel: ({ fill, ...props }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 1.5C4.1865 1.5 1.5 4.1865 1.5 7.5C1.5 10.8135 4.1865 13.5 7.5 13.5C10.8135 13.5 13.5 10.8135 13.5 7.5C13.5 4.1865 10.8135 1.5 7.5 1.5ZM8.207 7.5C8.207 7.5 9.7765 9.0695 9.8535 9.1465C10.049 9.342 10.049 9.6585 9.8535 9.8535C9.658 10.049 9.3415 10.049 9.1465 9.8535C9.0695 9.777 7.5 8.207 7.5 8.207C7.5 8.207 5.9305 9.7765 5.8535 9.8535C5.658 10.049 5.3415 10.049 5.1465 9.8535C4.951 9.658 4.951 9.3415 5.1465 9.1465C5.223 9.0695 6.793 7.5 6.793 7.5C6.793 7.5 5.2235 5.9305 5.1465 5.8535C4.951 5.658 4.951 5.3415 5.1465 5.1465C5.342 4.951 5.6585 4.951 5.8535 5.1465C5.9305 5.223 7.5 6.793 7.5 6.793C7.5 6.793 9.0695 5.2235 9.1465 5.1465C9.342 4.951 9.6585 4.951 9.8535 5.1465C10.049 5.342 10.049 5.6585 9.8535 5.8535C9.777 5.9305 8.207 7.5 8.207 7.5Z"
        fill={fill ? fill : "white"}
      />
    </svg>
  ),
  Notifications: ({ fill, ...props }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 122.88 122.83"
      {...props}
    >
      <path
        fill={fill ? fill : "red"}
        d="M73.81,7.47A43.14,43.14,0,0,1,92.69,19.35a42.33,42.33,0,0,1,10.76,21.36l0,.28c.21,1.21.36,2.36.45,3.44.11,1.26.17,2.53.17,3.8h0V58.36c0,2.81,0,5.67.2,8.54a32.41,32.41,0,0,0,4.34,14.62A36.6,36.6,0,0,0,120,92.83a6.34,6.34,0,0,1,2.65,3.65,6.52,6.52,0,0,1-.08,3.56,6.62,6.62,0,0,1-1.91,3,6.33,6.33,0,0,1-4.25,1.57H82.27l0,.08h0c-4.14,24.2-37.61,24.13-41.65-.08H6.45A6.33,6.33,0,0,1,2,102.92a6.6,6.6,0,0,1-1.81-6.5A6.33,6.33,0,0,1,3,92.71c5.66-3.83,9.62-8,12.12-12.76s3.65-10.44,3.65-17.28V48.23c0-1.16.06-2.42.18-3.77s.29-2.52.51-3.76A42.89,42.89,0,0,1,49.39,7.41C54-2.47,69.2-2.49,73.81,7.47ZM87.71,24A36.34,36.34,0,0,0,70.38,13.57,3.42,3.42,0,0,1,68,11.22c-1.71-5.87-11-6-12.72-.05a3.43,3.43,0,0,1-2.48,2.38A36.1,36.1,0,0,0,26.15,41.9q-.28,1.58-.42,3.15c-.09,1-.13,2-.13,3.18V62.67c0,7.91-1.38,14.56-4.45,20.43-2.94,5.62-7.36,10.39-13.54,14.72H115.27A42.38,42.38,0,0,1,102.8,85,39.18,39.18,0,0,1,97.5,67.4c-.22-2.88-.21-6-.2-9V48.23h0c0-1.1,0-2.17-.13-3.22s-.21-2-.36-2.85l-.06-.27a35.62,35.62,0,0,0-9-17.9Z"
      />
    </svg>
  ),
};

export default Icons;
